import React, { useEffect, useState } from 'react';
import { ShieldCheck, Ban, RotateCcw } from 'lucide-react';

const KEY = 'xincity_age_ok';

export default function AgeGate() {
  const [show, setShow] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    let ok = null;
    try { ok = sessionStorage.getItem(KEY); } catch (e) { ok = null; }
    if (ok !== 'yes') setShow(true);
  }, []);

  useEffect(() => {
    if (!show) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [show]);

  if (!show) return null;

  const confirmYes = () => {
    try { sessionStorage.setItem(KEY, 'yes'); } catch (e) {}
    setShow(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4" role="dialog" aria-modal="true" aria-label="Age verification">
      {/* Opaque backdrop so nothing inside is visible until verified */}
      <div className="absolute inset-0 bg-[#070609]" />
      <div className="absolute inset-0" style={{ background: 'radial-gradient(120% 90% at 20% 0%, rgba(122,24,255,0.22), transparent 55%), radial-gradient(120% 90% at 90% 20%, rgba(255,32,78,0.20), transparent 55%)' }} />
      <div className="absolute inset-0 xc-grid opacity-20" />

      <div className="relative w-full max-w-md xc-glass rounded-2xl border border-white/10 overflow-hidden xc-fade-up">
        <div className="px-7 py-6 text-center border-b border-white/8">
          <div className="font-display font-700 tracking-[0.24em] text-white text-xl">
            XINCITY<sup className="text-[0.5em] align-super text-white/60">™</sup>
          </div>
          <p className="text-[11px] tracking-[0.2em] uppercase text-white/40 mt-1">Live the city. Play your way.</p>
        </div>

        {denied ? (
          <div className="p-8 text-center">
            <div className="mx-auto h-14 w-14 rounded-full grid place-items-center mb-4" style={{ background: 'rgba(255,32,78,0.12)', border: '1px solid rgba(255,32,78,0.4)' }}>
              <Ban className="h-7 w-7 text-[#FF204E]" />
            </div>
            <h2 className="font-display font-700 text-xl text-white">You must be 18+ to enter</h2>
            <p className="text-sm text-white/55 mt-2 leading-relaxed">
              XINCITY™ is strictly for adults aged 18 or over. Access to the site is not permitted. If you or someone you know needs support, visit
              {' '}<a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="text-[#B026FF] underline">BeGambleAware.org</a>.
            </p>
            <button onClick={() => setDenied(false)} className="btn-ghost rounded-lg px-5 py-2.5 text-sm font-500 mt-6 inline-flex items-center gap-2">
              <RotateCcw className="h-4 w-4" /> I entered the wrong answer
            </button>
          </div>
        ) : (
          <div className="p-8 text-center">
            <div className="mx-auto h-16 w-16 rounded-full grid place-items-center mb-4" style={{ background: 'rgba(224,184,90,0.12)', border: '1px solid rgba(224,184,90,0.45)' }}>
              <span className="font-display font-700 text-[#E0B85A] text-lg">18+</span>
            </div>
            <h2 className="font-display font-700 text-2xl text-white tracking-tight">Are you 18 or older?</h2>
            <p className="text-sm text-white/55 mt-2 leading-relaxed">You must confirm you are of legal age to enter XINCITY™. This is a prototype — no real-money gambling.</p>
            <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <button onClick={confirmYes} className="btn-neon rounded-xl py-3.5 font-700 tracking-wide flex items-center justify-center gap-2">
                <ShieldCheck className="h-4 w-4" /> YES, I'M 18+
              </button>
              <button onClick={() => setDenied(true)} className="btn-ghost rounded-xl py-3.5 font-600 tracking-wide">
                NO
              </button>
            </div>
            <p className="text-[11px] text-white/35 mt-5 flex items-center justify-center gap-1.5">
              <ShieldCheck className="h-3.5 w-3.5 text-[#2FBF71]" /> Please gamble responsibly.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
